import React from "react";
import { RadioContainer, ToggleSwitch } from "../../commons";
import {
  UserProfileType,
  UserSettingsType,
} from "../../../redux/auth/authTypes";
import { RadioTypes } from "../../../commonTypes/universalTypes";

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "No",
  },
  {
    id: "1",
    name: "Yes",
  },
];

type AppProps = {
  userSetting?: UserSettingsType;
  setProfileForm: any;
};

const UsersSettings = ({ userSetting, setProfileForm }: AppProps) => {
  const handleToggleIsTrackAprovedEntries = (value: string) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_settings: {
          ...prv.user_settings,
          is_track_aproved_entries: value === "1" ? true : false,
          total_target_entries:
            value === "0" ? null : userSetting?.total_target_entries,
          is_disable_user: value === "0" ? false : userSetting?.is_disable_user,
        },
      };
    });
  };

  const handleToggleIsDisableUser = () => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_settings: {
          ...prv.user_settings,
          is_disable_user: !userSetting?.is_disable_user,
        },
      };
    });
  };

  const handleTotalTargetEntries = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_settings: {
          ...prv.user_settings,
          total_target_entries: data.replace(/[^0-9]/g, ""),
        },
      };
    });
  };

  const handleAutoDisableLoginToggle = () => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_settings: {
          ...prv.user_settings,
          is_track_timesheet_entry: !userSetting?.is_track_timesheet_entry,
        },
      };
    });
  };

  return (
    <div>
      <div>
        <h5>User Settings </h5>
      </div>
      <div className="mt-4">
        <label htmlFor="Track Aproved Entries" className="mr-3 pb-2">
          Track user's total approved entries?
        </label>
        <div className="d-flex align-items-center">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleToggleIsTrackAprovedEntries}
            radioValue={userSetting?.is_track_aproved_entries ? "1" : "0"}
            alignment="horizontal"
          />
        </div>
      </div>
      {userSetting?.is_track_aproved_entries && (
        <div className=" row mt-4 d-flex">
          <div className="col-md-2">
            <label htmlFor="status" className="mb-2">
              Target Entries<span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              pattern="[0-9]*"
              value={
                userSetting?.total_target_entries
                  ? userSetting?.total_target_entries
                  : ""
              }
              onChange={(e) => handleTotalTargetEntries(e.target.value)}
              onWheel={(event) => event.currentTarget.blur()}
            />
          </div>
          <div className="ml-3">
            <label htmlFor="Disable User" className="mr-2 mb-2">
              Disable user if target not achieved?
            </label>
            <ToggleSwitch
              handleToggleChange={handleToggleIsDisableUser}
              isChecked={userSetting?.is_disable_user}
              disabled={
                !userSetting?.total_target_entries ||
                userSetting?.total_target_entries == 0
              }
            />
          </div>
        </div>
      )}
      <div className="mt-2">
            <label htmlFor="Disable User" className="mr-2 mb-2">
              Auto-disable login after 3 days of missing timesheets?
            </label>
            <ToggleSwitch
              handleToggleChange={handleAutoDisableLoginToggle}
              isChecked={userSetting?.is_track_timesheet_entry}
            />
      </div>
      {/* {userSetting?.is_track_aproved_entries && (
        
      )} */}
    </div>
  );
};

export default UsersSettings;
